import { render, staticRenderFns } from "./store-detail-preview-upd.vue?vue&type=template&id=15faffe5&scoped=true&"
import script from "./store-detail-preview-upd.vue?vue&type=script&lang=js&"
export * from "./store-detail-preview-upd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15faffe5",
  null
  
)

export default component.exports